<template>
    <!-- <app-layout> -->

    <div class="mx-auto flex flex-grow flex-col" ref="mainContainer">



        <div v-if="showBulkActions"
            class="fixed left-auto bottom-5 right-10 bg-transparent pointer-events-none shadow-lg flex justify-center items-start px-6 h-20 z-50"
            :style="{ width: containerWidth + 'px' }">

            <BulkActionBar v-if="showBulkActions" :selectedVideos="selectedVideos" :way="way" ref="bulkActionBar"
                @unselectAllVideos="unselectAllVideos" @deletedSelectedVideos="deletedSelectedVideos"
                :currentFolder="currentFolder" :folders="folderList" :otherFolders="otherFolders"
                @movedSelectedVideos="movedSelectedVideos"></BulkActionBar>

        </div>

        <div class="w-full h-full">

            <div class="flex flex-col w-full">

                <div class="flex w-full justify-between items-center sm:px-6 lg:px-8 h-16 pt-5">

                    <div v-if="way != 'unified_personals'" class="flex w-full justify-start items-center">
                        <Folders :way="way" ref="folders" :currentFolder="currentFolder"
                            :canEdit="$page.props.canManageSettings" :folders="folderList"
                            @refreshFolderList="refreshFolderList" :plan_secure_folders="plan_secure_folders">
                        </Folders>
                    </div>
                    <div v-else class="flex w-full justify-start items-center">
                        <div class="font-bold">Unified Personals</div>
                    </div>

                    <div v-if="way == 'sent'" class="flex-shrink-0">
                        <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-12">
                            <div class="hidden md:flex flex-col items-center justify-center"></div>
                            <div class="hidden lg:flex flex-col items-end justify-center text-sm text-gray-500 gap-y-1">
                            </div>
                            <div class="flex flex-col items-center justify-center">
                                <div class="video-item flex flex-col mb-0 w-full">
                                    <Upload :way="way" @uploadSuccess="uploadSuccess" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 flex flex-grow pt-12 w-full">

                    <video-list :way="way" :search="search" :datacenter="datacenter" :currentFolder="currentFolder"
                        ref="videoList"></video-list>

                </div>

            </div>

        </div>

    </div>
    <!-- </app-layout> -->
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import VideoList from '@/Components/Video/VideoList'
import Upload from '@/Components/Video/Upload'

import Folders from '@/Components/UI/Folders'
import BulkActionBar from '@/Components/UI/BulkActionBar'



export default {
    props: ['way', 'search', 'datacenter', 'currentFolder', 'folders', 'otherFolders', 'plan_secure_folders'],
    components: {
        AppLayout,
        VideoList,
        Upload,
        Folders,
        //XMarkIcon, TrashIcon, FolderIcon,
        BulkActionBar

    },
    layout: AppLayout, // keep layout in place avoid refreshing it
    data() {
        return {
            containerWidth: 0,
            selectedVideos: [],
            folderList: this.folders
        }
    },
    created() {
        // this.EventBus.on("start.call", function(toto) {
        //     this.test(toto)
        // }.bind(this));
    },
    beforeUnmount() {
        // window.removeEventListener('resize', this.updateContainerDimensions)
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        }
    },
    mounted() {
        this.updateContainerDimensions()
        // window.addEventListener('resize', this.updateContainerDimensions)
        this.setupResizeObserver()
    },
    methods: {

        addSelectedVideos(video) {
            this.selectedVideos.push(video)
        },

        removeSelectedVideos(video) {
            this.selectedVideos = this.selectedVideos.filter(v => v.id !== video.id)
        },

        unselectAllVideos() {
            if (this.$refs.videoList) {
                this.$refs.videoList.unselectAllVideos()
                this.selectedVideos = []
            }
        },
        deletedSelectedVideos() {
            if (this.$refs.videoList) {
                const videoIds = this.selectedVideos.map(v => v.id)
                this.$refs.videoList.removeVideos(videoIds)
            }
            this.selectedVideos = []
        },
        movedSelectedVideos(folder) {
            if (this.$refs.videoList) {
                const videoIds = this.selectedVideos.map(v => v.id)
                this.$refs.videoList.removeVideos(videoIds)
            }
            this.selectedVideos = []
        },
        setupResizeObserver() {
            this.resizeObserver = new ResizeObserver(entries => {
                for (const entry of entries) {
                    this.containerWidth = entry.contentRect.width
                }
            })
            if (this.$refs.mainContainer) {
                this.resizeObserver.observe(this.$refs.mainContainer)
            }
        },
        updateContainerDimensions() {
            const parentContainer = document.querySelector('#app-layout-slot')
            if (parentContainer) {
                this.containerWidth = parentContainer.offsetWidth
                // this.containerLeft = parentContainer.getBoundingClientRect().left
            }
        },
        uploadSuccess() {
            const routename = this.way == 'my' ? 'library.personal' : 'library.team'
            this.$inertia.get(route(routename));
        },
        refreshFolderList(list) {
            this.folderList = list
        }
        // test(toto) {
        //     console.log("test ok", toto)
        // }
        // createNewFolder() {
        //     if (this.$refs['folders']) {
        //         this.$refs['folders'].createNewFolder()
        //     }
        // }
    },
    computed: {
        showBulkActions() {
            return this.selectedVideos.length > 0
        }
    }
}
</script>
